import { EventEmitter } from "events";

const eventEmitter = new EventEmitter();

export const AUTH_EVENTS = {
  STORE_AUTH_DETAILS: "STORE_AUTH_DETAILS",
  SESSION_EXPIRED: "SESSION_EXPIRED",
  AUTH_ERROR: "AUTH_ERROR",
  NEED_AUTH: "NEED_AUTH",
};

export const emitStoreAuthDetails = (details) => {
  eventEmitter.emit(AUTH_EVENTS.STORE_AUTH_DETAILS, details);
};

export const emitSessionExpired = () => {
  eventEmitter.emit(AUTH_EVENTS.SESSION_EXPIRED);
};

export const emitAuthError = (error) => {
  eventEmitter.emit(AUTH_EVENTS.AUTH_ERROR, error);
};

export const emitNeedAuth = () => {
  eventEmitter.emit(AUTH_EVENTS.NEED_AUTH);
};

export default eventEmitter;
